import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { deleteCompanyUser, companyUserDeleted } from 'actions/company';

import { Link } from 'react-router';
import NavBarConfig from 'components/NavBarConfig';

const messages = defineMessages({
  BACK: {
    id: 'CompanyUserDeletePage.BACK',
    defaultMessage: 'Zurück',
  },
  DELETE_USER: {
    id: 'CompanyUserDeletePage.DELETE_USER',
    defaultMessage: 'Benutzer löschen',
  },
  REALLY_WANT_TO_DELETE: {
    id: 'CompanyUserDeletePage.REALLY_WANT_TO_DELETE',
    defaultMessage: 'Sind sie sich sicher, dass sie den Benutzer wirklich löschen wollen?',
  },
  CAN_NOT_REVOKED: {
    id: 'CompanyUserDeletePage.CAN_NOT_REVOKED',
    defaultMessage: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  BUTTON_DELETE_USER: {
    id: 'CompanyUserDeletePage.BUTTON_DELETE_USER',
    defaultMessage: 'Benutzer unwiderruflich löschen',
  },
});

function CompanyUserDeletePage({
  company,
  companyUser,
  onSubmit,
  routes,
  location,
  intl: { formatMessage },
}) {
  if (!companyUser) {
    return null;
  }
  const fromList = location && location.query && location.query.from === 'list';

  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig deletePage currentRouteName={routes[routes.length - 1].name} />
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '700px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={fromList ? `/company/${company.id}/user/` : `/company/${company.id}/user/${companyUser.user_id}/`} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.DELETE_USER)}
            </h2>
          </div>
          
          {/* Main Card */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '16px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px' }}>
            <div style={{ padding: '16px', backgroundColor: 'rgba(239, 68, 68, 0.1)', borderLeft: '4px solid #ef4444', borderRadius: '8px', marginBottom: '24px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <i className="fa fa-exclamation-triangle" style={{ color: '#ef4444', fontSize: '20px', marginTop: '2px' }} />
              <div>
                <p style={{ margin: 0, color: 'var(--text-color)', fontSize: '14px', fontWeight: '500' }}>
                  {formatMessage(messages.REALLY_WANT_TO_DELETE)}
                  <br />
                  {formatMessage(messages.CAN_NOT_REVOKED)}
                </p>
              </div>
            </div>
            <button
              className="lh-btn lh-btn-block"
              onClick={onSubmit}
              style={{ marginTop: '15px', backgroundColor: '#ef4444', color: '#fff', border: 'none' }}
              type="button"
            >
              <span className="fa fa-trash" />
              {' '}{formatMessage(messages.BUTTON_DELETE_USER)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null, (dispatch, { params }) => ({
  onSubmit: () =>
    deleteCompanyUser(params.companyId, params.userId).then(() => {
      dispatch(companyUserDeleted({ companyId: params.companyId, userId: params.userId }));
      dispatch(push(`/company/${params.companyId}/user/`));
    }),
}))(injectIntl(CompanyUserDeletePage));
